/* global Metro */
(function(Metro, $) {
    $.extend(Metro.locales, {
        'ru-RU': {
            "calendar": {
                "months": [
                    "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
                    "Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"
                ],
                "days": [
                    "Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота",
                    "Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб",
                    "Вос", "Пон", "Вто", "Сре", "Чет", "Пят", "Суб"
                ],
                "time": {
                    "days": "ДНИ",
                    "hours": "ЧАСЫ",
                    "minutes": "МИН",
                    "seconds": "СЕК",
                    "month": "МЕС",
                    "day": "ДЕНЬ",
                    "year": "ГОД"
                },
                "weekStart": 1
            },
            "buttons": {
                "ok": "ОК",
                "cancel": "Отмена",
                "done": "Готово",
                "today": "Сегодня",
                "now": "Сейчас",
                "clear": "Очистить",
                "help": "Помощь",
                "yes": "Да",
                "no": "Нет",
                "random": "Случайно",
                "save": "Сохранить",
                "reset": "Сброс"
            },
            "table": {
                "rowsCount": "Показать записей:",
                "search": "Поиск:",
                "info": "Показаны $1 с $2 по $3 записей",
                "prev": "Предыдущие",
                "next": "Следующие",
                "all": "Все",
                "inspector": "Инспектор",
                "skip": "Перейти на страницу",
                "empty": "Нет записей"
            },
            "colorSelector": {
                addUserColorButton: "ДОБАВИТЬ В ОБРАЗЦЫ",
                userColorsTitle: "ЦВЕТА ПОЛЬЗОВАТЕЛЯ"
            },
            "switch": {
                on: "вкл",
                off: "выкл"
            }
        }
    });
}(Metro, m4q));